import styles from './style.module.scss';

interface Props {
    toggled: boolean;
    setToggle: any;
    disable?: boolean;
};

function Toggle(props: Props) {
    const { toggled, setToggle, disable } = props;

    const click = () => {
        if (disable) return;
        setToggle(!toggled);
    };

    return (
        <div className={styles.wrapper}>
            <div
                onClick={click}
                data-toggle-on={toggled}
                className={styles.toggle}
                data-toggle-disable={disable}
            >
                <span className={styles.toggle_btn}></span>
            </div>
        </div>
    );
};

export default Toggle;
